import { Button } from "@mantine/core";
import { IconShieldCheck } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { SetupAuthenticatorAppModal } from "./SetupAuthenticatorAppModal";
import { usePendingTOTPSecret } from "../hooks/usePendingTOTPSecret";

interface SetupAuthenticatorAppButtonProps {
	onSuccess?: () => void;
	modalSize?: "md" | "lg" | "xl";
}

export function SetupAuthenticatorAppButton({
	onSuccess,
	modalSize = "md",
}: SetupAuthenticatorAppButtonProps) {
	const [modalOpened, setModalOpened] = useState(false);
	const { restoredSecretKey } = usePendingTOTPSecret();

	useEffect(() => {
		if (restoredSecretKey) {
			setModalOpened(true);
		}
	}, [restoredSecretKey]);

	const handleSuccess = () => {
		onSuccess?.();
		setModalOpened(false);
	};

	return (
		<>
			<Button
				variant="light"
				leftSection={<IconShieldCheck size={16} />}
				onClick={() => setModalOpened(true)}
			>
				Setup Authenticator App
			</Button>

			<SetupAuthenticatorAppModal
				opened={modalOpened}
				onClose={() => setModalOpened(false)}
				onSuccess={handleSuccess}
				size={modalSize}
			/>
		</>
	);
}
